export default function AboutSection() {
  return (
    <section id="sobre" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20business%20consultation%20in%20modern%20office%20with%20warm%20lighting%2C%20two%20people%20reviewing%20documents%20at%20desk%2C%20clean%20minimal%20interior%20design%2C%20teal%20and%20warm%20neutral%20tones%2C%20trust%20and%20professionalism%20atmosphere%2C%20editorial%20photography%20style&width=800&height=600&seq=about-2026-x1&orientation=landscape"
                alt="Consultoria profissional RCRED"
                className="w-full h-64 md:h-80 object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 md:-right-6 bg-primary-500 text-white rounded-xl p-4 md:p-6 shadow-lg">
              <p className="text-3xl md:text-4xl font-bold font-heading">15+</p>
              <p className="text-sm text-primary-100">Anos de Experiência</p>
            </div>
          </div>

          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-medium">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              Sobre a RCRED
            </div>

            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              Quem Somos
            </h2>

            <div className="space-y-4 text-foreground-700 leading-relaxed">
              <p>
                A RCRED Negócios Financeiros é uma empresa especializada em soluções de crédito
                imobiliário, com mais de 15 anos de experiência no mercado financeiro. Nosso
                compromisso é transformar sonhos em realidade, oferecendo as melhores condições
                para aquisição de imóveis e investimentos.
              </p>
              <p>
                Atuamos com parcerias estratégicas junto aos principais bancos e instituições
                financeiras do país, garantindo aos nossos clientes taxas competitivas e um
                processo de aprovação ágil e transparente.
              </p>
              <p>
                Nosso time de consultores especializados está preparado para oferecer um
                atendimento personalizado, entendendo as necessidades específicas de cada cliente
                e indicando a melhor solução financeira para cada perfil.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4 pt-4">
              <div className="text-center p-4 bg-background-100 rounded-xl">
                <p className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">2.000+</p>
                <p className="text-xs text-foreground-600 mt-1">Clientes Atendidos</p>
              </div>
              <div className="text-center p-4 bg-background-100 rounded-xl">
                <p className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">R$ 500M+</p>
                <p className="text-xs text-foreground-600 mt-1">Em Financiamentos</p>
              </div>
              <div className="text-center p-4 bg-background-100 rounded-xl">
                <p className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">98%</p>
                <p className="text-xs text-foreground-600 mt-1">Satisfação</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}